import classnames from 'classnames';

// components
import { makeStyles } from '@mui/styles';
import { SimpleSelect } from '../../../../components/inputs';

export const EnhancedSelect = ({ coverage, ...props }: any) => {
  const classes = useSelectStyles(coverage);
  const className = classnames('normal-text', {
    [classes.selected]: coverage.selected,
    [classes.mandatory]: coverage.mandatory,
    [classes.locked]: coverage.locked && !coverage.disabled,
    [classes.disabled]: props.disabled,
    [classes.default]: props.default,
  });

  return <SimpleSelect className={className} {...props} />;
};

const useSelectStyles = makeStyles(({ palette }) => {
  return {
    mandatory: {
      '& > div, & > svg': {
        color: `${palette.common.cowbellBlue} !important`,
        WebkitTextFillColor: `${palette.common.cowbellBlue} !important`,
      },
    },

    selected: {
      '& > div, & > svg': {
        color: palette.common.cowbellGreen2,
        WebkitTextFillColor: palette.common.cowbellGreen2,
      },
    },

    default: {
      '& > div, & > svg': {
        color: palette.primary.main,
        WebkitTextFillColor: palette.primary.main,
      },
    },

    disabled: {
      '& > div, & > svg': {
        color: palette.primary.contrastText,
        opacity: palette.mode === 'light' ? '0.5 !important' : 1,
        WebkitTextFillColor: palette.primary.contrastText,
      },

      '& > svg': {
        display: 'none',
      },
    },

    locked: {
      color: `${palette.primary.oldBorder} !important`,
      WebkitTextFillColor: `${palette.primary.oldBorder} !important`,

      '& > svg': {
        display: 'none',
      },
    },
  };
});
